import styles from './index.less'
import assetSvg from './images/asset.svg'
import { useState } from 'react'
import { Modal } from 'antd'
import openPayDialog from '@/components/PayDialog'
import {setShowRewardPop} from '@/states/store'
import { MemberType } from '@/constants'

export default ({ userInfo = {}, isShow }: any) => {
  const [count, setCount] = useState(230)

  const [showWhatIsModal, setShowWhatIsModal] = useState(false)
  
  const wlMap: any = {
    A: 1500,
    B: 300,
  };
  
  const priceMap: any = {
    A: 19.8,
    B: 3.9,
  };

  const openPay = (type: number) => {
    openPayDialog({
      onClose: (userInfo:any) => {
        // console.log('onClose?????',userInfo)
      },
      type,
    })
  }

  const mouseHover=()=>{
    setShowRewardPop(false)
  }
  return (
    <>
      <div className={styles.assetWrapper}>
        <button className={styles.asset} onMouseEnter={mouseHover}>
          <img src="https://cdn2.weimob.com/saas/saas-fe-sirius-orion-node/production/zh-CN/483/anniu_dou.png" alt="" />
          {userInfo?.balance || '0'}
        </button>
        <div className={styles.placeWrapper}>
          <div className={styles.assetPopup}>
            <p className={styles.title}>剩余微力</p>
            <div className={styles.count}>
              <img src="https://cdn2.weimob.com/saas/saas-fe-sirius-orion-node/production/zh-CN/483/anniu_dou.png" />
              {userInfo?.balance || '0'}
            </div>
            {!(userInfo?.oemFlag===1)&&<a className={styles.rule} onClick={() => setShowWhatIsModal(true)}>
              规则说明 &gt;
            </a>}
            {!(userInfo?.oemFlag===1)&&<button className={styles.beingVipBtn} onClick={() => openPay(1)}>
              {
                (userInfo.memberStatus === MemberType.未开通||userInfo.memberStatus === MemberType.已过期) && !userInfo?.specialInfo?.isBuyGoods10&&<div className={styles.btnTips}>送{wlMap?.[userInfo?.specialInfo?.g] || 300}微力</div>
              }
              {
                userInfo.memberStatus === MemberType.已开通 ? '续费会员' : `${userInfo?.specialInfo?.isBuyGoods10?'开通会员':`开通会员，低至¥${priceMap?.[userInfo?.specialInfo?.g] || 9.9}`}`
              }
            </button>}
            <button className={`${userInfo?.oemFlag === 1 ? styles.chargeBtnOem : styles.chargeBtn}`} onClick={() => openPay(2)}>
              充值微力
            </button>
          </div>
        </div>
      </div>
      <Modal
        className={styles.whatIsModal}
        onCancel={() => setShowWhatIsModal(false)}
        open={showWhatIsModal}
        footer={null}
        width={680}
        title="微力规则"
      >
        <div className={styles.paragraph}>
        <p>1、什么是微力？</p> 
        微力是一种可用于使用平台上的部分权益功能服务的虚拟商品，用户可以通过开通会员、充值加油包等途径获得微力。用户在使用部分功能及服务时可以消耗微力。
        </div>
        <div className={styles.paragraph}>
        <p>2、微力怎么获取？</p> 
        微力主要通过开通会员、购买加油包获得；
        <br />
        通过开通会员获得的微力按月发放，直到会员失效后停止发放；
        <br />
        通过加油包购买的微力购买后将立即发放。
        </div>
        <div className={styles.paragraph}>
        <p> 3、微力怎么消耗？</p> 
        用户在系统内使用部分功能服务将会消耗数量不等的微力；
        <br />
        通过开通会员获得的微力有过期时间，每月到期将自动清空；
        <br />
        通过加油包获得的微力永久有效，但需在会员套餐有效期之内使用，若会员到期，则加油包微力冻结不可使用；
        <br />
        微力的消耗记录均可在“个人中心-微力记录”中查看（仅记录近1年消耗记录）。
        <br />
        </div>
        <div className={styles.paragraph}>
        <p> 4、注册用户活动</p> 
        新注册用户在注册后一年内每月赠送200微力，可用于体验系统内功能，若赠送的200微力在月末未使用完毕，将会被清空。
        </div>
        <div className={styles.paragraph}>
        <p> 5、微力支持退款吗？</p> 
        微力系充值类虚拟商品，一旦充值成功，即视为您认可该商品，即便您未兑换使用任何相关权益，无特殊情况下，微力不予退还。
        </div>
        <div className={styles.paragraph} style={{marginBottom:0}}>
        <p>  6、对生成效果不满可以退还微力吗？</p> 
        非常抱歉，效果一旦生成，不支持退还微力，但若生成过程存在问题导致生成失败，我们将会自动退还至您的账户。
        </div>
      </Modal>
    </>
  )
}
